import { render, staticRenderFns } from "./enterpriseModelManagement.vue?vue&type=template&id=60ba63f0&scoped=true"
import script from "./enterpriseModelManagement.vue?vue&type=script&lang=js"
export * from "./enterpriseModelManagement.vue?vue&type=script&lang=js"
import style0 from "./enterpriseModelManagement.vue?vue&type=style&index=0&id=60ba63f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba63f0",
  null
  
)

export default component.exports